"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_FNS_LOCALE_OPTIONS = void 0;
const da_1 = __importDefault(require("date-fns/locale/da"));
const en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
const fi_1 = __importDefault(require("date-fns/locale/fi"));
const nb_1 = __importDefault(require("date-fns/locale/nb"));
const sv_1 = __importDefault(require("date-fns/locale/sv"));
const enums_1 = require("@bemlo/enums");
// Note: date-fns formats are not compatible with DayJs formats
exports.DATE_FNS_LOCALE_OPTIONS = {
    [enums_1.Locale.DA]: {
        dateFormat: {
            long: 'D. MMMM YYYY',
            short: 'DD.MM.YYYY',
        },
        locale: da_1.default,
    },
    [enums_1.Locale.EN]: {
        dateFormat: {
            long: 'd MMM yyyy',
            short: 'd MMM yy',
        },
        locale: en_GB_1.default,
    },
    [enums_1.Locale.FI]: {
        dateFormat: {
            long: 'D. MMMM[ta] YYYY',
            short: 'D.M.YYYY',
        },
        locale: fi_1.default,
    },
    [enums_1.Locale.NB]: {
        dateFormat: {
            long: "d'.' MMM yyyy ('uke 'w)",
            short: 'd.M.yyyy',
        },
        locale: nb_1.default,
    },
    [enums_1.Locale.SV]: {
        dateFormat: {
            long: "d MMM yyyy ('v'w)",
            short: 'd/M yyyy',
        },
        locale: sv_1.default,
    },
};
